import { render, staticRenderFns } from "./MoFoot.vue?vue&type=template&id=640ecaee&scoped=true&"
import script from "./MoFoot.vue?vue&type=script&lang=js&"
export * from "./MoFoot.vue?vue&type=script&lang=js&"
import style0 from "./MoFoot.vue?vue&type=style&index=0&id=640ecaee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ecaee",
  null
  
)

export default component.exports